module.exports = __webpack_public_path__ + "img/icon-image.a710e427.svg";